/**
 * Chave do telefone digitado em "Criar contato" (drawer do contato).
 *
 * Espelha a regra de envio do backend (`services/contact_identity.to_send_digits`)
 * sem biblioteca de telefonia no cliente. A chave precisa sair na hora, a cada
 * dígito: etapa, tag, campo e comentário escolhidos ANTES de salvar gravam nela,
 * e o responsável e a conversa criados no salvar também. Uma ida ao servidor por
 * dígito traria de volta os dois cadastros órfãos do mesmo lead (achado N3).
 *
 * - Com "+", o operador declarou o país: vale como veio.
 * - Sem "+", DDD + número (10 ou 11 dígitos) ganha o 55, menos o número do plano
 *   +1 (EUA e Canadá) que não forma telefone brasileiro válido.
 * - 55 colado na frente de um número +1 inválido no Brasil é desfeito.
 *
 * Número de outro país fora do plano +1 digitado sem "+" continua ganhando 55
 * aqui (validar exigiria a tabela de numeração de cada país). A tela orienta a
 * começar com "+".
 */

// DDDs que existem no Brasil: o mesmo conjunto do metadata do libphonenumber
// que o backend usa.
const DDD_BR = /^(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])$/;

const somenteDigitos = (valor) => String(valor || '').replace(/\D/g, '');

/** DDD + número forma telefone brasileiro válido? Celular 9 + 8 dígitos (ou
 *  7 + 7), fixo [2-5] + 7. */
export const isBrNationalNumber = (valor) => {
  const d = somenteDigitos(valor);
  if (d.length !== 10 && d.length !== 11) return false;
  if (!DDD_BR.test(d.slice(0, 2))) return false;
  return /^(?:9\d{8}|7\d{7}|[2-5]\d{7})$/.test(d.slice(2));
};

/** Número do plano +1 já com o código do país: 1 + área + central + 4 dígitos
 *  (área e central nunca começam com 0 ou 1). */
export const isNanpNumber = (valor) => /^1[2-9]\d{2}[2-9]\d{6}$/.test(somenteDigitos(valor));

export const normalizeCreatePhone = (raw) => {
  const texto = String(raw || '').trim();
  const d = somenteDigitos(texto);
  if (!d) return '';
  if (texto.startsWith('+')) return d;
  if (d.length === 10 || d.length === 11) {
    // Brasileiro válido vence: '12987654321' é celular de São José dos Campos.
    if (!isBrNationalNumber(d) && isNanpNumber(d)) return d;
    return `55${d}`;
  }
  if (d.length === 13 && d.startsWith('55')) {
    const resto = d.slice(2);
    if (!isBrNationalNumber(resto) && isNanpNumber(resto)) return resto;
  }
  return d;
};
